import { Selector } from 'reselect'

import {
  SnackbarState,
} from '../../../types/frontend/store'

import {
  RootState,
} from '../../../types/frontend/store_generic'

export const data: Selector<RootState, SnackbarState> = state => state.snackbar

export default {
  data,
}
